import { PopperContent } from '@/components/poppers/PopperContent';

export function TrustGrantors() {
  return (
    <PopperContent
      body={'The individual(s) that created and funded this entity.'}
    />
  );
}
